import { eventTypeIntro } from "@/mocks/eventsData";
import { useScrollReveal, useStaggerReveal } from "@/hooks/useScrollReveal";
import Icon from "@/components/feature/Icon";

export default function EventsIntroSection() {
  const { ref: headerRef, style: headerStyle } = useScrollReveal();
  const { containerRef, getItemStyle } = useStaggerReveal(eventTypeIntro.length, 100);

  return (
    <section className="pt-16 pb-20 md:pt-20 md:pb-28 bg-navy-950 relative overflow-hidden">
      {/* Animated background grid */}
      <div className="absolute inset-0 opacity-[0.03]">
        <div
          className="w-full h-full animate-grid-move"
          style={{
            backgroundImage:
              "linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)",
            backgroundSize: "100px 100px",
          }}
        />
      </div>

      {/* Floating orbs */}
      <div className="absolute top-[5%] left-[15%] w-56 h-56 rounded-full bg-white/[0.02] blur-3xl animate-float-1" />
      <div className="absolute bottom-[10%] right-[5%] w-48 h-48 rounded-full bg-silver-300/[0.02] blur-3xl animate-float-2" />

      <div className="relative z-10 px-6 md:px-10 lg:px-16">
        <div ref={headerRef} style={headerStyle} className="max-w-3xl mb-12 md:mb-16">
          <p className="text-sm font-medium tracking-[0.2em] text-silver-400 uppercase mb-3">
            What We Do
          </p>
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-semibold text-white mb-4">
            協會活動類型
          </h2>
          <p className="text-silver-300 text-base md:text-lg leading-relaxed">
            TAIAA 全年規劃多元活動，從產業論壇到實作工作坊，從學術研討到人才培訓，串連產官學研各方力量，推動台灣 AI 應用發展。
          </p>
        </div>

        <div ref={containerRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-14">
          {eventTypeIntro.map((type, index) => (
            <div
              key={type.title}
              style={getItemStyle(index)}
              className="group bg-white/5 border border-white/10 rounded-xl p-6 md:p-7 hover:bg-white/10 hover:border-white/20 hover:-translate-y-1 transition-all duration-500"
            >
              <div className="w-11 h-11 rounded-lg bg-white/10 flex items-center justify-center mb-4 group-hover:scale-105 transition-transform"
              >
                <Icon className={`${type.icon} text-white text-lg`} />
              </div>
              <h3 className="text-white font-semibold text-base mb-2">
                {type.title}
              </h3>
              <p className="text-silver-400 text-sm leading-relaxed">
                {type.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="#upcoming-events"
            className="inline-flex items-center gap-2 bg-white text-navy-950 px-7 py-3.5 rounded-full text-sm font-medium hover:bg-silver-100 transition-colors whitespace-nowrap"
          >
            查看近期活動
            <Icon className="ri-arrow-down-line" />
          </a>
        </div>
      </div>
    </section>
  );
}